import React, { useState } from "react";
import queryString from "query-string";

import "./FakeHelperOptionsModal.scss";
import DebugJSON from "../DebugJSON/DebugJSON.js";

const generateRandomUserId = () => {
  return `FAKE_${Math.round(Math.random() * 99999)}`;
};

const FakeHelperOptionsModal = () => {
  const savedOptions = localStorage.getItem("fakeHelperOptions")
    ? JSON.parse(localStorage.getItem("fakeHelperOptions"))
    : {};
  const [options, setOptions] = useState({
    channel_id: savedOptions.channel_id || "DEBUG_CHANNEL",
    user_id: savedOptions.user_id || generateRandomUserId(),
    role: "viewer",
    is_linked: true,
  });

  const handleChangeInput = (e) => {
    setOptions((options) => ({
      ...options,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    }));
  };

  const handleGenerateRandomUserId = () => {
    setOptions((options) => ({
      ...options,
      user_id: generateRandomUserId(),
    }));
  };

  const handleSaveChanges = () => {
    window.location.search = queryString.stringify(options);
  };

  return (
    <div className="fake-helper-modal">
      <h1>Testing options</h1>

      <p>
        <small>
          The extension is being tested outside of Twitch. To continue testing,
          please enter the following options to simulate the extension being
          used by a Twitch viewer or broadcaster.
        </small>
      </p>

      <p>
        <small>
          <strong>
            To change these options, press F2 while the extension is active.
          </strong>
        </small>
      </p>

      <label>
        <h3>Channel ID</h3>
        <input
          type="text"
          name="channel_id"
          value={options.channel_id}
          onChange={handleChangeInput}
        />
      </label>

      <label>
        <h3>User ID</h3>
        <input
          type="text"
          name="user_id"
          value={options.user_id}
          onChange={handleChangeInput}
        />
        <button onClick={handleGenerateRandomUserId}>
          Generate random user ID
        </button>
      </label>

      <label>
        <h3>Role</h3>
        <select name="role" value={options.role} onChange={handleChangeInput}>
          <option value="viewer">Viewer</option>
          <option value="broadcaster">Broadcaster</option>
        </select>
      </label>

      <h3>Identity</h3>
      <label>
        <input
          type="checkbox"
          name="is_linked"
          checked={options.is_linked}
          onChange={handleChangeInput}
        />
        Identity is shared
      </label>

      <br />
      <div>
        <button onClick={handleSaveChanges}>Save changes</button>
      </div>
    </div>
  );
};

export default FakeHelperOptionsModal;
